const initialState = {
    message: '',
};
const complaint = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_INPUTS_PAGE_COMPLAINT':
            return {...state, [action.name]:  action.value};
        default:
            return state;
    }
};

export default complaint;